import React, {useState, useEffect} from "react";
import assets from "../assets/imgs";
import config from "../config/config";
const API_URL = config.API_URL;

const currentYear = new Date().getFullYear();

function MyPageCompanyCard({style, modal, onClose, 
  // basicInfo, briefInfo, detailInfo, memberInfo, 
  startupId }) {
  const [fixOrNot, setFixOrNot] = useState(false); // 수정, 저장 기능
  //false (수정 버튼 활성화 일때만 activeFix 가 false를 가질수도 있음)
  //true (저장하기 버튼 나와있을때)는 activeFix 는 무조건 true
  const [activeFix, setActiveFix] = useState(true); // 수정권한이 있는지 없는지 체크

  const [basicInfo, setBasicInfo] = useState([]);
  const [briefInfo, setBriefInfo] = useState([]);
  const [detailInfo, setDetailInfo] = useState([]);
  const [memberInfo, setMemberInfo] = useState([]);
  const [dataLoad, setDataLoad] = useState(true);
  const [loading, setLoading] = useState(true);

  const [memberList, setMemberList] = useState([]);
  const [perfList, setPerfList] = useState([]);
  const [detailList, setDetailList] = useState([]);

  // const [formData, setFormData] = useState(basicInfo || {});
  const [formData, setFormData] = useState([]);
  
  // API 호출 함수
  const fetchData = async () => {
    try {
      const response = await fetch(`${API_URL}/api/startup/getStartupCard`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        ...(startupId && {body: JSON.stringify({startup_id: startupId})})
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      // console.log(result.value);

      if (result.result) {        
        setBasicInfo(result.value.startup_info);       
        setMemberInfo(result.value.member_info);
        setBriefInfo(result.value.perf_summary);
        setDetailInfo(result.value.perf_detail);  
      } else {
        console.error("데이터 가져오기 실패:", result.message);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      // setError(error.message); // 에러 메시지 저장
    } finally {
      setDataLoad(false); // 데이터 로딩 완료
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  // 연도별 데이터 정리 후 perfList 업데이트
  const years = new Set([
    currentYear - 4,
    currentYear - 3,
    currentYear - 2,
    currentYear - 1,
    currentYear,
  ]);

  useEffect(() => {
    if (!dataLoad) {
      setFormData(basicInfo); // 가변정보
      
      //불변정보
      // memberList 업데이트
      setMemberList(
        memberInfo.length > 0
        ? memberInfo.map(member => ({
            role: member.role || "-",
            name: member.name || "-",
            yearOfBirth: member.birth_date || "2010",
            contact: member.phone_nb || "-",
            university: member.university || "-",
            education: member.education_level || "-",
          }))
        : [{ role: "-", name: "-", yearOfBirth: "-", contact: "-", university: "-", education: "-" }]
        // memberInfo.map(member => ({
        //   role: member.role || "-",
        //   name: member.name || "-",
        //   yearOfBirth: member.birth || "2010",
        //   contact: member.phone_nb || "-",
        //   university: member.university || "-",
        //   education: member.education_level || "-",
        // }))
      );
  
      setPerfList(
        briefInfo && Object.keys(briefInfo).length > 0
        ? Array.from(years).map(year => ({
            year: Number(year),
            sale: (briefInfo.sales?.[year] || 0).toLocaleString(),
            investment: (briefInfo.invests?.[year] || 0).toLocaleString(),
            support: (briefInfo.support_projects?.[year] || 0).toLocaleString(),
            intellectual: (briefInfo.intellectual_properties?.[year] || 0).toLocaleString(),
            hiring: 0, // 채용 정보가 없으므로 기본값 설정
          }))
        : [{ year: currentYear, sale: "0", investment: "0", support: "0", intellectual: "0", hiring: 0 }]
        // Array.from(years).map(year => ({
        //   year: Number(year),
        //   sale: (briefInfo.sales?.[year] || 0).toLocaleString(),
        //   investment: (briefInfo.invests?.[year] || 0).toLocaleString(),
        //   support: (briefInfo.support_projects?.[year] || 0).toLocaleString(),
        //   intellectual: (briefInfo.intellectual_properties?.[year] || 0).toLocaleString(),
        //   hiring: 0, // 채용 정보가 없으므로 기본값 설정
        // }))
      );

      setDetailList(
        detailInfo && Object.keys(detailInfo).length > 0
        ? {
            year: detailInfo.year,
            investment: detailInfo.invests,
            support: detailInfo.support_projects,
            contest: detailInfo.prizes,
            intellectual: countIntellectualProperties(detailInfo.intellectual_properties),
          }
        : {
            year: currentYear,
            investment: [
              { invests_date: "-", investor: "-", invest_type: "-", amount: 0 },
            ],
            support: [
              { start_date: "-", end_date: "-", supporter: "-", project_name: "-", amount: 0 },
            ],
            contest: [
              { prize_date: "-", organization: "-", contest: "-", prize: "-", amount: 0},
            ],
            intellectual: {
              patentUp: 3,
              tradeMarkUp: 2,
              designUp: 1,
              utilityPatentUp: 0,
              patentDone: 1,
              tradeMarkDone: 1,
              designDone: 0,
              utilityPatentDone: 0,
            },
          }
      );
    }
  }, [dataLoad]); // fetchData 후 상태 변경 시 실행

  useEffect(() => {
    // console.log(memberList.length > 0, perfList.length > 0, detailList, formData);
    // console.log(memberList, perfList);
    if (memberList.length > 0 && perfList.length > 0 && detailList && formData) {
      // console.log("모든 데이터 설정 완료, loading 상태 변경");
      setLoading(false);
    }
  }, [memberList, perfList, detailList, formData]);

  // const memberList = memberInfo.map(member => ({
  //   role: member.role || "-",
  //   name: member.name || "-",
  //   yearOfBirth : member.birth || "2010",
  //   contact: member.phone_nb || "-",
  //   university: member.university || "-",
  //   education : member.education_level || "-",
  // }));
  
  // // 연도별 데이터 정리
  // const years = new Set([
  //   currentYear - 4,
  //   currentYear - 3,
  //   currentYear - 2,
  //   currentYear - 1,
  //   currentYear,
  //   // ...Object.keys(briefInfo.intellectual_properties),
  //   // ...Object.keys(briefInfo.invests),
  //   // ...Object.keys(briefInfo.sales),
  //   // ...Object.keys(briefInfo.support_projects),
  // ]);

  // const perfList = Array.from(years).map(year => ({
  //   year: Number(year),
  //   sale: (briefInfo.sales[year] || 0).toLocaleString(),
  //   investment: (briefInfo.invests[year] || 0).toLocaleString(),
  //   support: (briefInfo.support_projects[year] || 0).toLocaleString(),
  //   intellectual: (briefInfo.intellectual_properties[year] || 0).toLocaleString(),
  //   hiring: 0, // 채용 정보가 없으므로 기본값 설정
  // }));

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };
  
  // const detailList = {
  //   year: detailInfo.year,
  //   investment: [
  //     { date: "2023-01-01", company: "A 투자사", name: "Series A", amount: "1억 원" },
  //     { date: "2023-06-15", company: "B 투자사", name: "Series B", amount: "5억 원" },
  //   ],
  //   support: [
  //     { date: "2023-03-01", organization: "중소기업청", team: "창업지원팀", name: "기술개발", amount: "5000만 원" },
  //     { date: "2023-07-20", organization: "서울특별시", team: "산업진흥원", name: "시장조사", amount: "3000만 원" },
  //   ],
  //   contest: [
  //     { date: "2023-08-01", organization: "과학기술부", mainOrganization: "KIST", name: "기술혁신대회", prize: "대상", amount: "1억 원" },
  //     { date: "2023-10-10", organization: "산업통상자원부", mainOrganization: "KOTRA", name: "수출혁신대회", prize: "최우수상", amount: "5000만 원" },
  //   ],
  //   intellectual: {
  //     patentUp: 3,
  //     tradeMarkUp: 2,
  //     designUp: 1,
  //     utilityPatentUp: 0,
  //     patentDone: 1,
  //     tradeMarkDone: 1,
  //     designDone: 0,
  //     utilityPatentDone: 0,
  //   },
  // };

  const countIntellectualProperties = (intellectualProperties) => {
    const counts = {
      patentUp: 0,
      tradeMarkUp: 0,
      designUp: 0,
      utilityPatentUp: 0,
      patentDone: 0,
      tradeMarkDone: 0,
      designDone: 0,
      utilityPatentDone: 0,
    };
  
    intellectualProperties?.forEach(({ type, status }) => {
      let typeKey = "";
      let statusKey = status === "출원" ? "Up" : "Done";
  
      switch (type) {
        case "특허":
          typeKey = "patent";
          break;
        case "상표권":
          typeKey = "tradeMark";
          break;
        case "디자인":
          typeKey = "design";
          break;
        case "실용신안":
          typeKey = "utilityPatent";
          break;
        default:
          return; // 알 수 없는 타입이면 무시
      }
  
      counts[`${typeKey}${statusKey}`]++;
    });
  
    return counts;
  };

  const handleFix = async ()=>{
    if(fixOrNot){//저장하기 일때 저장하기 기능 수행
      try{
        const requestBody={
          // startup_id : 1,
          ...(startupId ? { startup_id: startupId } : {}), // startupId가 있을 때만 추가
          startup_info : formData,
        }
        const response = await fetch(`${API_URL}/api/startup/fixStartupCard`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body : JSON.stringify(requestBody),
          credentials: "include"
        });
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();

        if(result.result){
          alert("저장에 성공하였습니다.");
          setFixOrNot(false);          
        }else{
          alert("저장에 실패했습니다 :", result.message);
        }
      }catch(error){
        console.error("Error fetching card data:", error);
        alert("저장에 실패했습니다.");
      }            

    }else{//수정 버튼 뜰때
      setFixOrNot(true);
    }
  }

  return (
    <div>
      {loading ? (
        <p>Loading...</p>
        ):(
          <div className="commonComponent" style={{...style, padding: "20px", margin: "16px"}}>
            <div style={styles.header}>
              <p className="font-s-head4-semibold">입주기업 관리카드</p>
              <div style={styles.headerRight}>
                <button style={{...styles.fixButton,
                  backgroundColor: activeFix ? "var(--primary-crimson_40)" : "var(--grayscale_50)",
                  color: activeFix ? "white" : "var(--grayscale_70)",
                  cursor: activeFix ? "pointer" : "default",
                }} 
                  onClick={activeFix ? handleFix : null}
                  className="font-body2-semibold">{fixOrNot ? "저장하기" : "수정"}
                </button>
                {modal && <div style={styles.xBox} onClick={onClose}><assets.icons.icon_x /></div>}          
              </div>
              
            </div>
            <div style={styles.tableContainer}>
              {/* Section: Company Information */}
              <Section title="기업현황" prop={{borderTopLeftRadius : "16px"}}>
                <RowCompany 
                  data={formData} fixOrNot={fixOrNot} onInputChange={handleInputChange}
                  />
              </Section>

              {/* Section: Team Information */}
              <Section title="입주팀" >
                <RowTeam cells={memberList} />
              </Section>

              {/* Section: Performance */}
              <Section title="성과">
                <RowPerformance cells={perfList} />
              </Section>

              {/* Section: Detailed Achievements */}
              <Section title="성과 세부내용">
                <RowDetail cells={detailList} />
              </Section>

              {/* Section: Intellectual Property */}
              <Section title="아이템 등" prop={{borderBottomLeftRadius : "16px"}}>
                <RowItem data={formData} fixOrNot={fixOrNot} onInputChange={handleInputChange}/>
              </Section>

            </div>
          </div>
        )
      }
    </div>    
  );
};

const transformDate = (value) =>{
  if (!value) return null;
  const date = new Date(value);
  const formattedDate = `${date.getFullYear()}년 ${String(date.getMonth() + 1).padStart(2, '0')}월 ${String(date.getDate()).padStart(2, '0')}일`;
  return formattedDate;
};


const calculateAge = (birth) => {
  
  const birthDate = new Date(birth);
  if(!birth || isNaN(birthDate)){
    return 0;
  }
  const today = new Date();
  
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  const dayDiff = today.getDate() - birthDate.getDate();

  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    age--;
  }

  // console.log("birth:", birth, ", age:", age);

  return age;
};

// 사용 예시
const basicInfo = {
  birth: "2014-05-14",
};

// 재사용 가능한 Section 컴포넌트
const Section = ({ title, children, prop}) => (
  <div style={styles.section}>
    <div style={{...styles.sectionTitle, ...prop}} className="font-body3-bold">
      {title}
    </div>
    {children}
  </div>
);

const RowCompany = ({data, fixOrNot, onInputChange}) => {
    const fields = [
      { label: "기업명", key: "name", isEditable: true, rowOrder: 1, inputType: "text"},
      { label: "구분", key: "company_type", isEditable: true, rowOrder: 1 , inputType: "select", options: ["본점", "지점", "연구소", "예비창업"],},
      { label: "업력", key: "establish_duration", isEditable: false, inputType: "text", rowOrder: 1, },
  
      { label: "주소", key: "address", isEditable: true, rowOrder: 2,inputType: "text" },
  
      { label: "홈페이지", key: "homepage", isEditable: true, rowOrder: 3, inputType: "text" },
  
      { label: "사업자형태", key: "company_type", isEditable: true, rowOrder: 4, inputType: "select", options: ["개인", "법인", "예비"], },
      { label: "사업자등록번호", key: "company_number", isEditable: true, rowOrder: 4, inputType: "text" },
  
      { label: "설립일", key: "establishment_date", isEditable: true, rowOrder: 5, inputType: "date" },
      { label: "캠퍼스 타운 입주일", key: "move_in_date", isEditable: true, defaultValue: "-", rowOrder: 5, inputType: "date" },
  
      { label: "교내 창업", key: "startOnCampus", isEditable: true, rowOrder: 6, inputType: "select", options: ["예", "아니오"] },
      { label: "외국인 창업", key: "foreign", isEditable: true, rowOrder: 6, inputType: "select", options: ["예", "아니오"]  },
      { label: "소셜 벤쳐", key: "social", isEditable: true, rowOrder: 6, inputType: "select", options: ["예", "아니오"]  },
  
      { label: "업종(품목)", key: "industry_type", isEditable: true, rowOrder: 7, inputType: "text" }
    ];
  
    // rowOrder 별로 그룹화
    const groupedFields = fields.reduce((acc, field) => {
      if (!acc[field.rowOrder]) acc[field.rowOrder] = [];
      acc[field.rowOrder].push(field);
      return acc;
    }, {});
    return(
      <div style={styles.sectionContents}>
        {Object.entries(groupedFields).map(([rowOrder, group], index) => (
          <div style={styles.row} key={index}>
            {group.map(({ label, key, isEditable, inputType, options }) => {
              switch (parseInt(rowOrder)) {
                case 2: // 주소 (2줄 처리)
                  return (
                    <React.Fragment key={key}>
                      <div style={{ ...styles.cell, ...styles.titleCell, ...styles.titleCell_top }}>{label}</div>
                      <div style={{ ...styles.cell, flex: 1, flexDirection: "column"}}>
                        {fixOrNot && isEditable ?(
                          <input
                            type="text"
                            value={data[key] || ""}
                            onChange={(e) => onInputChange(key, e.target.value)}
                            style={{ ...styles.cell, ...styles.inputStyle, ...styles.doubleHeightCell,
                             }}
                          />
                        ): (
                          <>
                            <div style={{...styles.cell, width: "100%"}}>{(data[key] || "").substring(0, 10)}</div>
                            <div style={styles.cell}>{(data[key] || "").length > 10 ? data[key].substring(10) : ""}</div>
                          </>                          
                        )}
                      </div>
                    </React.Fragment>
                  );
                default: // 기본적인 필드 렌더링
                  return (
                    <React.Fragment key={key}>
                      <div style={{ ...styles.cell, ...styles.titleCell, ...styles.titleCell_top }}>{label}</div>
                      <div style={styles.cell}>{renderInput({fixOrNot : fixOrNot, isEditable : isEditable, key: key, 
                        inputType:inputType, options: options, onInputChange: onInputChange, data: data})}</div>
                    </React.Fragment>
                  );
              }
            })}
          </div>
        ))}
      </div>
    );
};

const RowTeam = ({ cells }) => {
  const keyToContents = {
    role: "직책",
    name: "성명",
    yearOfBirth: "출생연도",
    contact: "연락처",
    university: "대학",
    education: "학력"
  };
  return(
    <div style={styles.sectionContents}>
      {/* 타이틀 헤더 생성 */}
      <div style={styles.row}>
        {Object.values(keyToContents).map((title, index) => (
          <div key={index} style={index === 0 
            ? {...styles.rowTitleBox, ...styles.titleCell_top }
            : {...styles.rowTitleBox}
          } className="font-body3-bold">
            {title}
          </div>
        ))}
      </div>
      {/* 데이터 로우 생성 */}
      {cells.map((cell, index) => (
        <div key={index} style={styles.row}>
          {Object.keys(keyToContents).map((key, idx) => (
            <div
              key={idx}
              style={
                key === "role"
                  ? { ...styles.cell, ...styles.titleCell, ...styles.titleCell_top }
                  : styles.cell
              }
            >
              {(() => {
                const value = cell[key];
                if (!value) return "-";

                if (key === "yearOfBirth") {
                  const date = new Date(value);
                  return isNaN(date.getTime()) ? "-" : date.getFullYear();
                }

                return value;
              })()}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
  
};

const RowPerformance = ({ cells }) => {
  const keyToContents = {
    sale: "매출액(원)",
    investment: "투자유치액 (원)",
    support: "지원사업선정 (원)",
    intellectual: "지식재산권 (건)",
    hiring: "고용 (명)",
  };

  return (
    <div style={styles.sectionContents}>
      {/* 연도 표시 */}
      <div style={styles.row}>
        <div style={{...styles.rowTitleBox, ...styles.titleCell_top}}>연도</div>
        {cells.map((cell, index) => {
          const isFuture = parseInt(cell.year, 10) >= currentYear; // 연도 비교
          return (
            <React.Fragment key={index}>
              <div style={styles.rowTitleBox}>
                {cell.year}
                {isFuture ? " (예정)" : ""}
              </div>
            </React.Fragment>
          );
        })}
      </div>
      <div style={styles.row}>
        {/* KeyToContents 타이틀 */}
        <div style={{...styles.columnPerformance, ...styles.titleCell_top}}>
          {Object.values(keyToContents).map((title, index) => (
            <div
              key={index}
              style={{...styles.cell, ...styles.titleCell }}
            >
              {title}
            </div>
          ))}
        </div>
        {/* 데이터 표시 */}
        {cells.map((cell, index) => (
          <div style={styles.columnPerformance} key={index}>
            {Object.keys(keyToContents).map((key, idx) => (
              <div
                key={`${index}-${idx}`}
                style={{ ...styles.cell }}
              >
                {cell[key] || "-"} {/* 데이터 없으면 "-"로 표시 */}
              </div>
            ))}
          </div>
        ))}
          
      </div>
    </div>
  );

};

const RowDetail = ({ cells }) => {
  const investmentTitles = [
    { key: "invests_date", title: "투자일" },
    { key: "investor", title: "투자기관명" },
    { key: "invest_type", title: "투자명" },
    { key: "amount", title: "투자금액" },
  ];
  const supportTitles = [
    { key: "start_date", title: "시작날짜" },
    { key: "end_date", title: "종료날짜" },
    { key: "supporter", title: "전담기관명" },
    { key: "project_name", title: "사업명" },
    { key: "amount", title: "지원 금액" },
  ];
  const contestTitles = [ 
    { key: "prize_date", title: "수상일" },
    { key: "organization", title: "주관기관명" },
    { key: "contest", title: "대회명" },
    { key: "prize", title: "수상사항" },
    { key: "amount", title: "시상금액" },
  ];
  const intellectualTitles = [
    { key: "patentUp", title: "특허 출원" },
    { key: "tradeMarkUp", title: "상표권 출원" },
    { key: "designUp", title: "디자인 출원" },
    { key: "utilityPatentUp", title: "실용신안 출원" },
    { key: "patentDone", title: "특허 등록" },
    { key: "tradeMarkDone", title: "상표권 등록" },
    { key: "designDone", title: "디자인 등록" },
    { key: "utilityPatentDone", title: "실용신안 등록" },
  ];
  const sections = [
    {
      title: `${cells.year}년 투자실적`,
      titles: investmentTitles,
      data: cells.investment,
    },
    {
      title: `${cells.year}년 지원사업 수행이력(정부 지자체 등 창업사업화 자금지원)`,
      titles: supportTitles,
      data: cells.support,
    },
    {
      title: `${cells.year}년 공모전 경진대회 수상이력(정부 지자체 시상금 수령)`,
      titles: contestTitles,
      data: cells.contest,
    },
  ];

  return (
    <div style={styles.performanceContents}>
      {sections.map((section, sectionIndex) => (
        <div key={sectionIndex}>
          {/* 섹션 제목 */}
          <div style={styles.rowTitleBox}>{section.title}</div>
          
          {/* 타이틀 Row */}
          <div style={styles.row}>
            {section.titles.map(({ title }, index) => (
              <div key={index} style={{...styles.cell, ...styles.titleCell}}>{title}</div>
            ))}
          </div>

          {/* 데이터 Rows */}
          <div>
            {section.data.map((cell, dataIndex) => (
              <div key={dataIndex} style={styles.row}>
                {section.titles.map(({ key }, keyIndex) => {
                  let value = cell[key];
                  if(key === "amount"){
                    value = formatKoreanCurrency(cell[key]);
                  }
                  return(
                    <div key={keyIndex} style={styles.cell}>{value || "-"}</div>
                  );
                })}
              </div>
            ))}
          </div>
        </div>
      ))}

      {/* 지적재산권 */}
      <div>
        {Array.from({ length: Math.ceil(intellectualTitles.length / 4) }, (_, rowIndex) => (
          <div key={rowIndex} style={styles.row}>
            {intellectualTitles
              .slice(rowIndex * 4, rowIndex * 4 + 4)
              .map(({ key, title }, colIndex) => (
                <div key={colIndex} style={styles.row}>
                  <div style={{...styles.cell, ...styles.titleCell, ...styles.titleCell_bottom}}>{title}</div>
                  <div style={styles.cell}>{cells.intellectual[key] || "-"}</div>
                </div>
              ))}
          </div>
        ))}
      </div>
    </div>
  );
};

const RowItem = ({ data, fixOrNot, onInputChange}) => {
  const itemTitles = [
    { key: "company_item", label: "아이템명", isEditable: true, inputType: "text" },
    { key: "company_item_detail", label: "아이템 상세설명", isEditable: true, inputType: "text"  },
  ];

  return (
    <div style={{flex: 1}}>
      {itemTitles.map(({ key, label, isEditable, inputType }, index) => (
        <div style={styles.row} key={index}>
          <div style={{ ...styles.cell, ...styles.titleCell, ...styles.titleCell_bottom }}>
            {label}
          </div> {/* 제목 */}
          <div style={styles.cell}>
            {renderInput({fixOrNot : fixOrNot, isEditable : isEditable, data: data, key: key, 
              inputType:inputType, onInputChange})}
          </div> {/* 값 */}
        </div>
      ))}
    </div>
  );
};

const renderInput = ({ fixOrNot, isEditable, data, key, inputType, options, onInputChange }) => {
  if (!fixOrNot || !isEditable){//수정 완료 상태
    if(key === "establish_duration"){
      return calculateAge(data["deatablishment_date"]);
    }
    else if( key === "establishment_date"){
      return transformDate(data["establishment_date"]);
    }
    return data[key] || "-";
  }else{ // 수정 상태
    switch (inputType) {
      case "text":
        return (
          <input
            type={inputType}
            value={data[key] || ""}
            onChange={(e) => onInputChange(key, e.target.value)}
            style={{...styles.cell, ...styles.inputStyle}}
          />
        );
      case "date":
        return (
          <input
            type={inputType}
            value={data[key] || ""}
            onChange={(e) => onInputChange(key, e.target.value)}
            style={{...styles.cell, ...styles.inputStyle}}
          />
        );
      case "select":
        return (
          <select value={data[key] || ""} onChange={(e) => onInputChange(key, e.target.value)}
          style={{...styles.cell, ...styles.inputStyle}}>
            <option value="" disabled>선택</option>
            {options?.map((option, i) => (
              <option key={i} value={option}>
                {option}
              </option>
            ))}
          </select>
        );
      default:
        return data[key] || "";
    }
  }       
};

const formatKoreanCurrency = (amount) => {
  if (isNaN(amount) || amount === null || amount === undefined) return "0원";

  const units = ["", "만", "억", "조"]; // 한국 화폐 단위
  let result = [];
  let unitIndex = 0;

  while (amount > 0) {
    let part = amount % 10000; // 4자리씩 끊어서 처리
    if (part > 0) {
      result.unshift(`${part.toLocaleString()}${units[unitIndex]}`);
    }
    amount = Math.floor(amount / 10000);
    unitIndex++;
  }

  return result.length > 0 ? result.join(" ") + "원" : "0원";
};

const headFontStyle ={
  fontWeight: "bold",
  fontSize: "14px",
  lineHeight: "normal",
};
const contentsFontStyle ={
  fontWeight: "400",
  fontSize: "14px",
  lineHeight: "normal",
};

const styles={
  header : {
    display: "flex",
    justifyContent:"space-between",
    alignItems: "center",
    height : "48px",
    marginBottom: "20px",
  },
  headerRight: {
    display: "flex",
    gap: "44px", alignItems: "center", justifyContent: "center"
  },
  xBox:{
    display:"flex",
    alignItems:"center",
    justifyContent: "center",
    cursor:"pointer",
    width: "32px",
    height:"32px"
  },
  fixButton:{
    width: "150px",
    height: "48px",
    backgroundColor: "var(--grayscale_50)",
    color: "var(--grayscale_70)",
    borderRadius: "8px",
    border: "0px"
  },
  tableContainer: {
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    // padding: "20px",
    // backgroundColor: "#ffffff",
    // overflow: "hidden",
  },
  section: {
    width: "100%",
    display: "flex",
    borderBottom: "1px solid #f0f0f0"
  },
  sectionTitle: {
    backgroundColor: "#efd4d4",
    padding: "10px",
    fontWeight: "700",
    fontSize: "14px",
    color: "#353336",
    width: "144px",
    boxSizing: "border-box",
    display:"flex",
    justifyContent: "center",
    alignItems: "center",
  },
  sectionContents:{
    display: 'flex',
    flexDirection: "column",
    flex: 1,
  },
  row: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    minHeight: "40px"
  },
  cell: {
    flex: 1,
    textAlign: "center",
    borderBottom: "1px solid #f0f0f0",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "40px",
    ...contentsFontStyle,
  },
  doubleHeightCell: {
    minHeight: "80px"
  },
  titleCell: {
    backgroundColor: "#f0f0f0",
    fontWeight: "700",
    color: "#353336",
    ...headFontStyle,
  },
  titleCell_top:{
    flex: "none",
    width: "150px",
  },
  titleCell_bottom:{
    flex: "none",
    width: "115px",
  },
  titleCell_80:{
    flex: "none",
    width: "80px",
  },
  titleCell_125:{
    flex: "none",
    width: "125px",
  },
  inputStyle:{
    flex: 1,
    border: "none",
    textAlign: "center"
  },

  //입주팀 쪽 css
  rowTitleBox:{
    backgroundColor: "#E8E8E8",
    display:"flex",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    color: "var(--grayscale_90)",
    height: "40px",
    ...headFontStyle,
  },

  //performance
  columnPerformance:{
    flex: 1,
  },
  performanceContents:{
    display: "flex",
    flexDirection: "column",
    flex: 1,
  }
}

export default MyPageCompanyCard;